import { render, staticRenderFns } from "./booklet-template-gallery-image.vue?vue&type=template&id=2f26b629"
import script from "./booklet-template-gallery-image.vue?vue&type=script&lang=ts"
export * from "./booklet-template-gallery-image.vue?vue&type=script&lang=ts"
import style0 from "./booklet-template-gallery-image.vue?vue&type=style&index=0&id=2f26b629&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports